import React from "react";
import { Button } from "@fluentui/react-components";
import { Dismiss20Regular, Warning20Regular } from "@fluentui/react-icons";
import styles from "./Disclaimer.module.css";

interface DisclaimerProps {
    className?: string;
    fullDisclaimerUrl?: string;
    isVisible: boolean;
    onClose: () => void;
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ className, fullDisclaimerUrl = "#", isVisible, onClose }) => {
    if (!isVisible) return null;

    return (
        <div className={styles.disclaimerOverlay}>
            <div className={`${styles.disclaimer} ${className || ""}`}>
                <div className={styles.disclaimerContent}>
                    <Warning20Regular className={styles.disclaimerIcon} />
                    <div className={styles.disclaimerText}>
                        <span className={styles.disclaimerMainText}>
                            De AI-zoekassistent van STOWA geeft antwoord op basis van waarschijnlijkheden. Wil je zeker weten of het antwoord juist is, ga dan
                            altijd terug naar de specifieke STOWA-bron(nen) die worden genoemd. Het gebruik van de door de zoekassistent gepresenteerde kennis
                            is voor eigen risico.
                        </span>
                        <a href={fullDisclaimerUrl} className={styles.disclaimerLink} target="_blank" rel="noopener noreferrer">
                            Bekijk onze volledige verantwoording
                        </a>
                    </div>
                    <Button
                        appearance="subtle"
                        className={styles.closeButton}
                        icon={<Dismiss20Regular />}
                        title="Sluiten"
                        aria-label="Disclaimer sluiten"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default Disclaimer;
